module.exports = __webpack_public_path__ + "img/Angeschlagener_Raum_Schwalbennest.1f3a0875.svg";